var _path, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrLogoMob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 25,
    viewBox: "0 0 67 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71716 27L1.00009 20L7.71716 13",
    stroke: "#3B82F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.26697,
    y1: 19.9683,
    x2: 18,
    y2: 19.9683,
    stroke: "#3B82F6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4817 34.2402L48.6071 36.2138L37 6.07971H45.1063L50.9384 21.4448L53.7067 28.8293L55.0909 32.5216L55.4817 34.2402Z",
    fill: "url(#paint0_linear_382_9075)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6661 11.431V17.9612H46.3284V11.3383C46.1032 11.3383 45.8781 11.3781 45.6661 11.431Z",
    fill: "url(#paint1_linear_382_9075)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8514 13.8153V17.9744H45.6661V11.431C44.6197 11.7224 43.8514 12.6761 43.8514 13.8153Z",
    fill: "url(#paint2_linear_382_9075)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1756 9.31177C48.9504 9.31177 48.7252 9.3515 48.5133 9.40449V17.9745H49.1756V9.31177Z",
    fill: "url(#paint3_linear_382_9075)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6986 11.7887V17.9745H48.5133V9.40448C47.4669 9.69589 46.6986 10.6496 46.6986 11.7887Z",
    fill: "url(#paint4_linear_382_9075)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.349 6.76856V17.9744H52.0113V6.67584C51.7729 6.67584 51.5609 6.71558 51.349 6.76856Z",
    fill: "url(#paint5_linear_382_9075)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5343 9.15278V17.9744H51.349V6.76855C50.3026 7.05996 49.5343 8.01365 49.5343 9.15278Z",
    fill: "url(#paint6_linear_382_9075)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9922 17.1665C66.9657 15.7889 66.7008 14.4246 66.3564 13.0735C66.171 12.3715 65.9458 11.6695 65.7206 10.9145C65.5749 11.9874 65.5219 13.0205 65.2967 14.0007C65.2967 14.0272 65.2835 14.0537 65.2835 14.0802C64.6345 16.8883 62.8993 19.0341 60.8064 20.9017C58.9785 22.531 57.0579 24.0807 55.2432 25.7099C53.0312 27.6968 51.243 29.9883 50.2496 32.8361C50.2364 32.8891 50.1701 32.9289 50.0774 33.0216C50.1569 31.8162 50.4483 30.7301 50.9119 29.6969C51.8788 27.5511 53.4021 25.8159 55.0181 24.1469C56.5546 22.5575 58.144 21.0077 59.6276 19.3652C60.3826 18.5308 61.0449 17.5903 61.6409 16.6234C63.3099 13.908 63.4821 11.0337 62.3827 8.06664C61.7336 6.30496 60.8064 4.71548 59.7335 3.2452C58.8991 2.11932 57.9851 1.04641 57.0579 0C57.4818 1.96037 57.9851 3.93398 58.3295 5.93408C59.164 10.9145 57.8791 15.2856 54.422 19.0076C53.3888 20.1203 52.3954 21.2594 51.3755 22.3853C48.0376 26.0808 47.1236 30.4122 48.0773 35.1939C48.4482 37.0748 48.7131 38.7967 49.4681 40.7836C49.4813 40.8233 49.5078 40.8763 49.5608 41.022C49.9052 40.1743 50.2761 39.1014 50.647 38.2139C50.7 38.0947 50.7397 37.9887 50.7927 37.8695C52.3689 34.3462 54.8591 31.5513 57.8924 29.2201C59.5349 27.9617 61.2171 26.7431 62.8463 25.4583C64.8596 23.8555 66.4094 21.9084 66.8465 19.2858C66.9789 18.5705 67.0187 17.8685 66.9922 17.1665Z",
    fill: "url(#paint7_linear_382_9075)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0915 23.6966C64.0651 22.7032 63.8531 21.723 63.5617 20.7561C63.4028 20.2527 63.2173 19.7494 63.0451 19.2063C62.9259 19.9878 62.8729 20.7163 62.6875 21.4316C62.6875 21.4449 62.6743 21.4714 62.6743 21.4846C62.1312 23.5112 60.7006 25.0477 58.9522 26.3988C57.4289 27.5776 55.8527 28.677 54.3294 29.8691C52.5015 31.2997 51.0048 32.9421 50.1835 34.9952C50.1703 35.035 50.1173 35.0615 50.0511 35.1277C50.1173 34.2535 50.3557 33.4852 50.7399 32.7435C51.5346 31.1937 52.8062 29.9486 54.144 28.7433C55.4156 27.5909 56.7402 26.4782 57.972 25.2994C58.6078 24.7033 59.1509 24.0145 59.641 23.3258C61.0185 21.3786 61.1642 19.2991 60.2635 17.1665C59.7205 15.8949 58.9522 14.7558 58.0647 13.6961C57.376 12.8749 56.621 12.1066 55.8395 11.3516C56.1971 12.7689 56.6077 14.1862 56.8859 15.6167C57.5747 19.2063 56.515 22.3588 53.6407 25.0345C52.7797 25.8292 51.9585 26.6504 51.1107 27.4717C48.3291 30.1341 47.5741 33.2468 48.3689 36.6907C48.6868 38.0417 48.8987 39.2868 49.5345 40.7174C49.5477 40.7439 49.561 40.7836 49.614 40.8896C49.8921 40.2803 50.21 39.512 50.5147 38.8762C50.5544 38.7968 50.5942 38.704 50.6339 38.6246C51.9452 36.0814 54.0115 34.0813 56.5282 32.3991C57.8925 31.4851 59.2966 30.6109 60.6344 29.6837C62.3034 28.5313 63.5882 27.1273 63.9591 25.2331C64.0783 24.7033 64.1048 24.2 64.0915 23.6966Z",
    fill: "url(#paint8_linear_382_9075)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5469 19.8553C39.2026 20.107 38.9376 20.4779 38.7257 20.9283C42.1961 21.2461 43.865 23.5377 45.0174 26.3987C45.3751 27.273 45.64 28.2002 45.9976 29.2598C46.0903 28.6638 46.236 28.0809 46.395 27.5379C46.1301 26.7299 45.9049 26.0014 45.6267 25.2993C44.5141 22.5045 42.8849 20.2527 39.5469 19.8553Z",
    fill: "url(#paint9_linear_382_9075)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0509 18.3851C49.3753 18.3851 46.7129 18.3983 44.0372 18.3851C43.5207 18.3851 43.1233 18.5175 42.7921 18.9414C42.6729 19.0871 42.3948 19.1268 42.1828 19.1666C41.5205 19.299 40.845 19.3388 40.2092 19.5374C39.9708 19.6169 39.7589 19.7229 39.5602 19.8686C42.8981 20.2527 44.5141 22.5177 45.64 25.3126C45.9181 26.0146 46.1433 26.7431 46.4082 27.5511C46.7791 26.359 47.2957 25.2596 47.9182 24.2397C49.0176 22.0674 50.6071 20.2262 52.3026 18.4116C52.2098 18.3851 52.1304 18.3851 52.0509 18.3851Z",
    fill: "url(#paint10_linear_382_9075)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6005 28.6505C61.574 27.9352 61.4019 27.2332 61.1634 26.5312C61.031 26.1603 60.8853 25.8027 60.7263 25.4186C60.6336 25.9749 60.5806 26.5047 60.4349 27.0213C60.4349 27.0345 60.4217 27.0478 60.4217 27.061C59.9713 28.5181 58.7792 29.6307 57.3354 30.5976C56.0771 31.4454 54.7525 32.2401 53.4942 33.0878C51.9709 34.121 50.739 35.2999 50.0503 36.7834C50.037 36.8099 49.9973 36.8231 49.9311 36.8894C49.984 36.2668 50.1827 35.7105 50.5006 35.1674C51.1629 34.0548 52.2093 33.1541 53.322 32.2931C54.3816 31.4719 55.4678 30.6639 56.5009 29.8161C57.0308 29.379 57.4811 28.8889 57.8917 28.3988C59.0441 26.9948 59.1633 25.498 58.4083 23.9615C57.958 23.0476 57.3222 22.2263 56.5804 21.4581C56.0108 20.862 55.3751 20.3057 54.7393 19.7626C55.0307 20.7826 55.3751 21.8025 55.6135 22.8356C56.183 25.4186 55.3088 27.6836 52.9246 29.6175C52.2093 30.187 51.5338 30.7831 50.8318 31.3659C48.527 33.2733 47.9045 35.525 48.5668 38.002C48.8317 38.9822 49.0039 39.8696 49.5337 40.9028C49.5469 40.9293 49.5602 40.9558 49.5999 41.022C49.8383 40.5849 50.09 40.0286 50.3417 39.565C50.3814 39.4988 50.4079 39.4458 50.4476 39.3928C51.5338 37.5649 53.2557 36.1211 55.3353 34.9157C56.4744 34.2667 57.6268 33.6309 58.7395 32.9686C60.1303 32.1341 61.1899 31.1275 61.4946 29.7632C61.5873 29.379 61.6138 29.0214 61.6005 28.6505Z",
    fill: "url(#paint11_linear_382_9075)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5346 32.1209C59.5213 31.6043 59.3624 31.101 59.1637 30.5976C59.0577 30.3327 58.9253 30.0678 58.8061 29.7896C58.7266 30.187 58.6869 30.5711 58.5677 30.942C58.5677 30.9553 58.5544 30.9553 58.5544 30.9685C58.1835 32.0149 57.1901 32.8229 55.998 33.5117C54.9516 34.121 53.8522 34.6906 52.819 35.3131C51.5607 36.0549 50.5275 36.9026 49.9579 37.9755C49.9447 37.9887 49.9182 38.002 49.8652 38.0417C49.9049 37.5914 50.0771 37.194 50.3421 36.7966C50.8984 35.9886 51.7593 35.3528 52.6865 34.7303C53.5608 34.1342 54.4747 33.5647 55.3224 32.9421C55.7596 32.6375 56.1304 32.2798 56.4748 31.9222C57.4285 30.9155 57.5212 29.8426 56.8987 28.73C56.5278 28.0677 55.998 27.4849 55.3887 26.9286C54.9118 26.5047 54.3952 26.1073 53.8522 25.71C54.0906 26.4385 54.382 27.1802 54.5807 27.922C55.0575 29.7764 54.329 31.4189 52.3554 32.7964C51.7593 33.207 51.1898 33.6309 50.6202 34.0548C48.7128 35.4323 48.183 37.0483 48.7393 38.8365C48.9513 39.5385 49.097 40.1875 49.5341 40.9293C49.5473 40.9425 49.5606 40.969 49.587 41.022C49.7857 40.7041 49.9977 40.3067 50.2096 39.9756C50.2361 39.9359 50.2626 39.8829 50.2891 39.8431C51.1898 38.5318 52.6203 37.4854 54.3555 36.6112C55.296 36.1343 56.2629 35.684 57.1901 35.2071C58.3425 34.6111 59.2299 33.8826 59.4816 32.9024C59.5213 32.6375 59.5478 32.3726 59.5346 32.1209Z",
    fill: "url(#paint12_linear_382_9075)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_382_9075",
    x1: 46.5073,
    y1: 6.67586,
    x2: 46.5073,
    y2: 36.2138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_382_9075",
    x1: 45.9973,
    y1: 11.3383,
    x2: 45.9973,
    y2: 17.9612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_382_9075",
    x1: 44.7588,
    y1: 11.431,
    x2: 44.7588,
    y2: 17.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_382_9075",
    x1: 48.8444,
    y1: 9.31177,
    x2: 48.8444,
    y2: 17.9745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_382_9075",
    x1: 47.6059,
    y1: 9.40448,
    x2: 47.6059,
    y2: 17.9745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_382_9075",
    x1: 51.6801,
    y1: 6.67584,
    x2: 51.6801,
    y2: 17.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_382_9075",
    x1: 50.4416,
    y1: 6.76855,
    x2: 50.4416,
    y2: 17.9744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_382_9075",
    x1: 59.7193,
    y1: -3.41609e-7,
    x2: 48.8398,
    y2: 40.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3174E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_382_9075",
    x1: 56.0827,
    y1: 11.3516,
    x2: 56.0827,
    y2: 40.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_382_9075",
    x1: 38.8133,
    y1: 19.3057,
    x2: 46.4929,
    y2: 30.0785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_382_9075",
    x1: 45.9314,
    y1: 18.3851,
    x2: 45.9314,
    y2: 27.5511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_382_9075",
    x1: 54.9604,
    y1: 19.7626,
    x2: 54.9604,
    y2: 41.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF7900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_382_9075",
    x1: 54.0342,
    y1: 25.71,
    x2: 54.0342,
    y2: 41.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLogoMob);
export default __webpack_public_path__ + "static/media/arrLogoMob.894145cff624f61e9e3f25224eb39e04.svg";
export { ForwardRef as ReactComponent };